import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiChevronRight, FiMapPin, FiPhone } from "react-icons/fi";
import { Link } from 'react-router-dom'

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="header-left">
                            <p><a href="#link">Get the most advanced template <FiChevronRight /></a></p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right">
                            <div className="address-content">
                                <p><FiMapPin /><span>Tamilnadu, India</span></p>
                                <p><FiPhone /><span><a href="tel:+91 6383628551">+91 6383628551 </a></span></p>
                            </div>
                            <div className="social-icon-wrapper">
                                <ul className="social-icon social-default icon-naked">
                                    {/* <li><Link to="twitter.com"><FiFacebook /></Link></li>
                                    <li><Link to="twitter.com"><FiTwitter /></Link></li> */}
                                    <li>
                                          <a 
                                            href="https://www.instagram.com/jaz_infotech/?igsh=bW9haXlwaHcyOTBt#" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                          >
                                            <FiInstagram />
                                          </a>
                                    </li>
                                    <li>
                                          <a 
                                            href="https://www.linkedin.com/company/jaz-academy/" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                          >
                                            <FiLinkedin />
                                          </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
